import { render } from "./ReviewTaskCard.vue?vue&type=template&id=44f1a3aa&scoped=true"
import script from "./ReviewTaskCard.vue?vue&type=script&lang=js"
export * from "./ReviewTaskCard.vue?vue&type=script&lang=js"

import "./ReviewTaskCard.vue?vue&type=style&index=0&id=44f1a3aa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44f1a3aa"]])

export default __exports__